import { render, staticRenderFns } from "./DragDropOverlay.vue?vue&type=template&id=419438aa&scoped=true&"
import script from "./DragDropOverlay.vue?vue&type=script&lang=js&"
export * from "./DragDropOverlay.vue?vue&type=script&lang=js&"
import style0 from "./DragDropOverlay.vue?vue&type=style&index=0&id=419438aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419438aa",
  null
  
)

export default component.exports